module.exports = __webpack_public_path__ + "img/tab2_views@3x.6ccdcc87.png";